export default __webpack_public_path__ + "static/tablets-06c29ed6f6d8a271c326ed9b12dfaa3c.webm";